import { render, staticRenderFns } from "./ReportTerminalRelate.vue?vue&type=template&id=73ede751"
import script from "./ReportTerminalRelate.vue?vue&type=script&lang=js"
export * from "./ReportTerminalRelate.vue?vue&type=script&lang=js"
import style0 from "./ReportTerminalRelate.vue?vue&type=style&index=0&id=73ede751&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports